import React, { Component } from "react";
import { MandateDto } from 'ts-types/api.types';
import { getAllMandates, getAllMandatesWithDeleted } from 'services/mandateServices';
import axios, { CancelTokenSource } from 'axios';
import { noop } from 'utils/functionUtils';

const cancelTokenSource = axios.CancelToken.source();

interface State {
  currentMandates?: Array<MandateDto>,
  allMandates?: Array<MandateDto>,
  getAllMandates: () => void,
  getAllMandatesWithDeleted: () => void,
  cancelTokenSource: CancelTokenSource
}

interface Props {
  children: JSX.Element | Array<JSX.Element>
}

export const MandateContext = React.createContext<State>({
  getAllMandates: () => {},
  getAllMandatesWithDeleted: () => {},
  cancelTokenSource: cancelTokenSource
});

export class MandateProvider extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      currentMandates: [],
      allMandates: [],
      getAllMandates: this.getAllMandates,
      getAllMandatesWithDeleted: this.getAllMandatesWithDeleted,
      cancelTokenSource
    }
  }

  getAllMandates = () => {

    const { cancelTokenSource } = this.state;

    getAllMandates(cancelTokenSource).then((response) => {
      this.setState({
        currentMandates: response
      })
    }).catch(noop);
  };

  getAllMandatesWithDeleted = () => {

    const { cancelTokenSource } = this.state;

    getAllMandatesWithDeleted(cancelTokenSource).then((response) => {
      this.setState({
        allMandates: response
      })
    }).catch(noop)
  }

  render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
    return (
        <MandateContext.Provider value={this.state}>
          {this.props.children}
        </MandateContext.Provider>
    );
  }
}

export interface MandateConsumerRenderProps extends State {
}

export const withMandateContext = (Component: typeof React.Component | React.FunctionComponent<any>) => {
  return (props: any) => (
      <MandateContext.Consumer>
        {({...mandateConsumerRenderProps}: MandateConsumerRenderProps) => {
          return <Component {...props} {...mandateConsumerRenderProps} />
        }}
      </MandateContext.Consumer>
  );
};
